import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export const Container = styled.div<{
  $justifyContent?: string;
  $width?: string;
  $clickableRow: boolean;
}>`
  display: flex;
  flex-flow: row;
  column-gap: 10px;
  align-items: center;
  justify-content: ${(props) => props.$justifyContent || 'flex-start'};
  width: ${(props) => props.$width ?? 'auto'};
  cursor: ${(props) => (props.$clickableRow ? 'pointer' : 'default')};
`;
export const StyledCheckBox = styled.div<{
  disabled?: boolean;
  checked: boolean;
  $round?: boolean;
  $checkedColor?: string;
}>`
  border-radius: ${(props) => (props.$round ? '100%' : '2px')};
  display: flex;
  justify-content: center;
  min-width: 16px;
  min-height: 16px;
  align-items: center;
  ${({ checked, theme, disabled, $checkedColor }) =>
    checked
      ? `
    background-color: ${
      $checkedColor ?? theme.atlas.semantic.color.action.primary.default
    };
    ${disabled && 'opacity: 0.38;'}
  `
      : `
      background-color: ${
        disabled
          ? theme.atlas.semantic.color.action.primary.disabled
          : theme.atlas.semantic.color.surface.default
      };
      border: 1px solid ${
        disabled
          ? theme.atlas.semantic.color.ui.divider.default
          : theme.atlas.semantic.color.outline.default
      };
  `};
  @media (hover: hover) {
    &:hover {
      cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
    }
  }
`;
export const StyledCheckBoxLabel = styled.label<{
  disabled?: boolean;
  labelSize: 'regular' | 'large';
  $fullWidthLabel?: boolean;
}>`
  ${(props) =>
    textStyleCss(
      props.labelSize === 'regular'
        ? props.theme.atlas.typography.semantic.caption
        : props.theme.atlas.typography.semantic.bodySmall,
    )}
  color: ${({ theme, disabled }) =>
    disabled
      ? theme.atlas.semantic.color.type.muted
      : theme.atlas.semantic.color.type.default};
  max-width: ${(props) => (props.$fullWidthLabel ? 'none' : '110px')};
  white-space: ${(props) => (props.$fullWidthLabel ? 'normal' : 'nowrap')};
  overflow: ${(props) => (props.$fullWidthLabel ? 'visible' : 'hidden')};
  text-overflow: ${(props) => (props.$fullWidthLabel ? 'clip' : 'ellipsis')};
`;
